import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        token: '',
        signedIn: false,
        verified: false,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload.token
            state.verified = action.payload.verified
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.verified = false
            state.token = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        setVerified: (state, action) => {
            state.verified = action.payload
        }
    },
})

export const { onSignInSuccess, onSignOutSuccess, setToken, setVerified } = sessionSlice.actions

export default sessionSlice.reducer